module.exports = __webpack_public_path__ + "static/media/toolkitforuserinnovation.f7648e90.jpeg";